import { DBFactory } from "../../database/db_factory";
import { BaseModel } from "../base.model";

type RevisionEdistHistortyConstructorParams = {
  id?: string;
  documentId: string;
  revisionId: string;
  studentSubmissionOps: any;
  headers?: {
    alignment: "left" | "center" | "right";
    extraText?: string;
    includePageNumbers: boolean;
  }[];
  lastUpdatedTimestamp: number;
  editedByUserId: string;
  editedByUserName?: string;
};

export class RevisionEditHistory extends BaseModel {
  id?: string;
  documentId: string;
  revisionId: string;
  studentSubmissionOps: any;
  headers?: {
    alignment: "left" | "center" | "right";
    extraText?: string;
    includePageNumbers: boolean;
  }[];
  lastUpdatedTimestamp: number;
  editedByUserId: string;
  editedByUserName?: string;

  constructor(params: RevisionEdistHistortyConstructorParams) {
    super();
    this.id = params.id;
    this.documentId = params.documentId;
    this.revisionId = params.revisionId;
    this.studentSubmissionOps = params.studentSubmissionOps;
    this.headers = params.headers;
    this.lastUpdatedTimestamp = params.lastUpdatedTimestamp;
    this.editedByUserId = params.editedByUserId;
    this.editedByUserName = params.editedByUserName;
  }

  override get databaseConfig(): globalThis.ModelDatabaseConfig {
    return {
      collection: `/documents/${this.documentId}/revisions/${this.revisionId}/editingHistory`,
      path: `/documents/${this.documentId}/revisions/${this.revisionId}/editingHistory/${this.id}`,
    };
  }

  static override fromMap(
    map: globalThis.ModelDatabaseData
  ): RevisionEditHistory {
    return new RevisionEditHistory({
      id: map.id,
      documentId: map.documentId,
      revisionId: map.revisionId,
      studentSubmissionOps: map.studentSubmissionOps,
      headers: map.headers,
      lastUpdatedTimestamp: map.lastUpdatedTimestamp,
      editedByUserId: map.editedByUserId,
      editedByUserName: map.editedByUserName,
    });
  }

  async save() {
    const db = DBFactory.createDatabase();
    this.id = await db.save(this.toMap(), this.databaseConfig);
  }
}
